const countValidation = (validators, comments) => {
    if (!Array.isArray(validators) || validators.length === 0) {
        return { totalCount: 0, hasAllVoted: false, mixedVotes: false }
    }

    const validatorVotes = comments.filter((comment) => validators.some((v) => v.user_id === comment.user?.id))

    const approvedCount = validatorVotes.filter((c) => c.validation === 'approved').length
    const rejectedCount = validatorVotes.filter((c) => c.validation === 'rejected').length
    const totalVotes = approvedCount + rejectedCount

    const hasAllVoted = totalVotes === validators.length
    const mixedVotes = hasAllVoted && approvedCount > 0 && rejectedCount > 0

    return {
        totalCount: totalVotes,
        hasAllVoted,
        mixedVotes,
    }
}

export const constructValidation = (
    validation,
    chargingpoint,
    deletingCommentId = null,
    updatingComment = false,
    comments,
) => {
    const validators = chargingpoint?.properties?.validators || []
    const { hasAllVoted, mixedVotes } = countValidation(validators, comments || [])

    if (updatingComment && validators.length > 0) {
        const allApproved = validators.every((v) => comments.some((c) => c.user?.id === v.user_id && c.validation === 'approved'))

        if (hasAllVoted && allApproved) {
            return { id: 'validation_vote_updated_to_consensus' }
        } else if (hasAllVoted && mixedVotes) {
            return { id: 'validation_vote_updated_to_disagreement' }
        }
    }

    if (deletingCommentId !== null) {
        return {
            id: 'status_reset_after_validation_deleted',
            metadata: {
                oldStatus: chargingpoint.properties.status,
                newStatus: 'suggestion',
            },
        }
    }

    if (mixedVotes) return { id: 'status_auto_mixed' }

    if (validation === 'approved' && hasAllVoted && !mixedVotes) {
        return {
            id: 'status_auto_approved',
            metadata: {
                oldStatus: chargingpoint.properties.status,
                newStatus: 'definitive',
            },
        }
    }

    if (validation === 'rejected' && hasAllVoted && !mixedVotes) {
        return {
            id: 'status_auto_rejected',
            metadata: {
                oldStatus: chargingpoint.properties.status,
                newStatus: 'rejected',
            },
        }
    }

    return { id: validation }
}
